var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaginacaoPrimeira01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_to_first_page",
    d: "M6.2,34.9H0.5V1.1h5.7V34.9L6.2,34.9z M31.6,34.9L31.6,34.9L14.6,18L31.6,1.1l4,4l-13,13l13,13 L31.6,34.9L31.6,34.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaginacaoPrimeira01);
export default __webpack_public_path__ + "static/media/ico-paginacao-primeira-01.9a755bb4d510cc3633607d2db369a1e0.svg";
export { ForwardRef as ReactComponent };